<template>
  <div class="upload-cropper">
    <!-- 上传按钮 -->
    <el-upload
      :class="signatureType === 'yinzhang' ? 'Uploader2' : 'Uploader1'"
      action="#"
      :auto-upload="false"
      :show-file-list="false"
      :on-change="handleFileSelect"
      accept="image/*"
    >
      <img v-if="signatureUrl" :src="signatureUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"><span>裁剪上传</span></i>
    </el-upload>

    <!-- 裁剪对话框 -->
    <!-- 设置 :backgroundColor="null" 或 :backgroundColor="'transparent'"   PNG格式支持透明 -->
    <el-dialog
      title="修改图片"
      :visible.sync="dialogVisible"
      width="700px"
      top="5vh"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <!-- 裁剪区域 -->
      <div class="cropper-box">
        <vue-cropper
          ref="cropper"
          :img="imageSrc"
          :auto-crop="true"
          :fixed="isFixed"
          :fixed-number="aspectRatio"
          :center-box="true"
          :info="true"
          mode="contain"
          :backgroundColor="null"
          :output-type="'png'"
        />
      </div>

      <!-- 工具栏 -->
      <div class="toolbar">
        <el-button-group>
          <el-button @click="rotateLeft" size="mini">↺ 左转</el-button>
          <el-button @click="rotateRight" size="mini">↻ 右转</el-button>
          <!-- 当前裁剪组件不支持水平翻转 -->
          <!-- <el-button @click="scaleX" size="mini">↔ 翻转</el-button>
          <el-button @click="reset" size="mini">重置</el-button> -->
          <!-- 放大缩小按钮 -->
          <el-button @click="zoomOut" size="mini" icon="el-icon-minus">缩小</el-button>
          <el-button @click="zoomIn" size="mini" icon="el-icon-plus">放大</el-button>
          <!-- 添加更换图片按钮 -->
          <el-button @click="changeImage" size="mini" icon="el-icon-refresh">更换图片</el-button>
        </el-button-group>

        <el-select v-model="selectedRatio" size="mini" style="width: 120px;">
          <el-option label="自由比例" value="free"></el-option>
          <el-option label="1:1 正方形" value="1:1" v-if="signatureType=='yinzhang'"></el-option>
          <!-- <el-option label="4:3 标准" value="4:3"></el-option> -->
          <el-option label="16:9 宽屏" value="16:9" v-if="signatureType=='qianming'"></el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmCrop" size="small">确定上传</el-button>
      </span>
    </el-dialog>

    <!-- 隐藏的文件输入框，用于更换图片 -->
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'

export default {
  name: 'UploadCropper',
  components: { VueCropper },
  
  props: {
    // 默认宽高
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 300
    },
    // 最大文件大小(MB)
    maxSize: {
      type: Number,
      default: 5
    },

    signatureType: String,
    signatureUrl: String,  // 接收签名URL
  },

  data() {
    return {
      dialogVisible: false,
      isFixed: false,
      imageSrc: '',
      selectedRatio: '1:1',
      aspectRatio: [1, 1],
      zoomScale: 1, // 缩放比例
    }
  },

  watch: {
    selectedRatio(val) {
      if (val === 'free') {
        // this.$refs.cropper.fixed = false
        this.isFixed = false;
      } else {
        const [w, h] = val.split(':').map(Number)
        this.aspectRatio = [w, h]
        // this.$refs.cropper.fixed = true
        this.isFixed = true;
      }
      // 如果需要强制刷新裁剪器
      this.$nextTick(() => {
        if (this.$refs.cropper && this.$refs.cropper.refresh) {
          this.$refs.cropper.refresh();
        }
      });
    },
    // 监听签名URL变化
    signatureUrl(newVal) {
      if (newVal) {
        this.loadSignatureImage(newVal)
      }
    },
    // 监听type，切换默认的比例
    signatureType: {
      immediate: true, // 立即执行一次
      handler(newVal) {
        // if (newVal === 'yinzhang') {
        //   this.aspectRatio = [1, 1];
        //   this.selectedRatio = '1:1';
        //   this.isFixed = true
        // } else if (newVal === 'qianming') {
        //   this.aspectRatio = [16, 9];
        //   this.selectedRatio = '16:9';
        //   this.isFixed = true
        // }
        // 默认都使用自由比例
        this.selectedRatio = 'free';
        this.isFixed = false;
      }
    },
  },

  methods: {
    // 选择文件
    handleFileSelect(file) {
      if (!file) return

      // console.log(file.raw.type);
      // 电子印章只能是png格式
      const isImage = file.raw.type === 'image/png'; 
      const isLt2M = file.raw.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('上传图片只能是 PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return false;
      }

      // 转为base64
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
        this.dialogVisible = true
        // 重置缩放比例
        this.zoomScale = 1;
      }
      reader.readAsDataURL(file.raw)
    },

    // 旋转和缩放
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },

    rotateRight() {
      this.$refs.cropper.rotateRight()
    },

    // 放大
    zoomIn() {
      // this.zoomScale += 0.1
      // this.$refs.cropper.changeScale(this.zoomScale)
      this.$refs.cropper.changeScale(0.8) // 增加10%
    },

    // 缩小
    zoomOut() {
      // if (this.zoomScale > 0.2) { // 设置最小缩放比例
        // this.zoomScale -= 0.1
        // this.$refs.cropper.changeScale(this.zoomScale)
        this.$refs.cropper.changeScale(-0.8) // 减少10%
      // }
    },

    scaleX() {
      this.$refs.cropper.changeScaleX()
    },

    reset() {
      this.$refs.cropper.reset()
      this.zoomScale = 1; // 重置缩放比例
    },

    // 更换图片按钮点击事件
    changeImage() {
      // 触发隐藏的文件输入框
      this.$refs.fileInput.click()
    },

    // 处理更换图片
    handleFileChange(event) {
      const file = event.target.files[0]
      if (!file) return
      // 验证文件类型和大小
      const isImage = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;
      
      if (!isImage) {
        this.$message.error('上传图片只能是 PNG 格式!');
        return;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return;
      }

      // 读取新图片
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
        this.zoomScale = 1; // 重置缩放比例
        // 重置裁剪区域
        this.$nextTick(() => {
          if (this.$refs.cropper && this.$refs.cropper.reset) {
            this.$refs.cropper.reset()
          }
        })
      }
      reader.readAsDataURL(file)
      
      // 清空输入框，以便可以再次选择相同的文件
      event.target.value = ''
    },

    // 确认裁剪
    confirmCrop() {
      this.$refs.cropper.getCropBlob((blob) => {
        // 创建文件对象
        const file = new File([blob], `cropped_${Date.now()}.png`, {
          type: 'image/png'
        })
        // 上传成功之后，图片高宽比例不对,jpeg格式裁剪的高宽比例有偏差，使用png
        // console.log(file);
        // 触发事件，将文件数据传递给父组件
        this.$emit('confirm-crop', {
          file: file,
          url: URL.createObjectURL(blob),
          blob: blob
        })

        this.dialogVisible = false
        // this.$message.success('裁剪完成')
      })
    },

    loadSignatureImage(url) {
      // 使用URL加载图片到裁剪区域
      // 这里根据你的裁剪组件具体实现来写
      // console.log('加载签名图片:', url)
      this.signatureUrl = url;
    }
  }
}
</script>

<style lang='scss' scoped>
.upload-cropper {
  display: inline-block;
}

.cropper-box {
  width: 100%;
  height: 400px;
  background: #f8f9fa;
}

.toolbar {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-upload__tip {
  margin-top: 8px;
  color: #666;
  font-size: 12px;
}

      .Uploader1,.Uploader2 {
				width: 132px;
				height: 132px;
				background: #F9FAFC;
				border-radius: 4px;
				border: 1px solid #C0CCDA;
				position: relative;
			}
      .Uploader1{
        width: 180px;
        height: 132px;
      }
      .Uploader2{
        height: 132px;
      }
      .Uploader1 .avatar-uploader-icon,.Uploader2 .avatar-uploader-icon{
				line-height: 30px;
        margin: 40px 0;
			}
      .avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				text-align: center;
				line-height: 178px;
			}
      .avatar-uploader-icon span{font-size: 14px;display: block;line-height: 20px;}
      .avatar {
				width: auto;
				max-width: 100%;
				height: auto;
				max-height: 100%;
				display: block;
				position: absolute;
				top:50%; 
				left:50%;
				transform: translate(-50%,-50%);
			}
      /deep/.el-dialog__footer{
        text-align: right;
      }
</style>